import Link from 'next/link'
import Badge from './Badge'

interface Props {
  type: string
  size?: string
  children?: any
  href?: string
  className?: string
  badge?: any
  badgeRight?: string
  link?: boolean
  badgeClass?: string
  onClick?: (e: any) => void
}

const Button = ({
  type,
  onClick,
  children,
  href,
  size = 'normal',
  className = '',
  badge,
  badgeRight,
  badgeClass,
  ...rest
}: Props) => {
  const classes = {
    base: 'focus:outline-none transition ease-in-out duration-300 cursor-pointer rounded-full  whitespace-nowrap relative inline-block',
    size: {
      normal: 'py-2 px-9 text-base',
      medium: 'py-1.5 px-12 text-base',
      large: 'py-2 px-7 text-xl',
      big: 'py-3 px-10 text-2xl',
    },
    types: {
      primary:
        'bg-primary hover:bg-primary-hover text-white border-3 border-primary hover:border-primary-hover font-normal',
      secondary: 'border-3 border-black hover:bg-gray-dark',
      'secondary-selected': 'bg-black border-3 border-black text-white',
      white: 'border-3 bg-white border-gray-dark hover:border-black',
      action:
        'border-3 border-action bg-action text-white hover:bg-action-hover',
      muted: 'border-3 bg-gray-dark border-gray-dark text-white cursor-default',
      outlined: 'border-1 border-dark hover:bg-gray',
      naked: 'bg-transparent border-3 border-transparent hover:border-black',
    },
    badgeClass: 'absolute',
  } as const

  const badgeStyle = {
    position: 'absolute',
    top: '-22px',
    right: badgeRight || '10px',
    transform: 'rotate(-10deg)',
  }

  return (
    <>
      {href ? (
        <Link
          href={href}
          {...rest}
          prefetch={false}
          onClick={onClick}
          className={`${className} ${classes.base} ${
            classes.size[size?.toLowerCase() as 'large' | 'normal']
          } ${classes.types[type.toLowerCase() as 'primary' | 'secondary']}`}
        >
          <span className='flex items-center justify-center w-full'>
            {badge ? (
              <Badge
                className={`${classes.badgeClass} ${badgeClass}`}
                title={badge}
                style={badgeStyle}
              />
            ) : (
              ''
            )}
            {children}
          </span>
        </Link>
      ) : (
        <button
          type='button'
          onClick={onClick}
          className={`${className} ${classes.base} ${
            classes.size[size?.toLowerCase() as 'large' | 'normal']
          } ${classes.types[type.toLowerCase() as 'primary' | 'secondary']}`}
          {...rest}
        >
          <span className='flex items-center justify-center w-full h-full'>
            {badge ? (
              <Badge
                className={`${classes.badgeClass} ${badgeClass}`}
                title={badge}
                style={badgeStyle}
              />
            ) : (
              ''
            )}
            {children}
          </span>
        </button>
      )}
    </>
  )
}

export default Button
